// extracted by css-extract-rspack-plugin
export default {"modalList":"modal-list--XV9DohH8BoTbiOly"};